import React, { Component } from 'react'
import SubSubTask from '../SubSubTask/SubSubTask'
import {TaskDatePopup} from '../TaskDatePopup/TaskDatePopup'
import './subtasks.css'

class Subtask extends Component {
    constructor() {
        super()
        this.state = {
            dateChange: false
        }
    }

    componentDidMount(){
        let subtaskId = "subtask-" + this.props.subTask.subtaskId
        document.getElementById(subtaskId).style.opacity = 0
        setTimeout(() => {
            if(document.getElementById(subtaskId)){
                document.getElementById(subtaskId).style.opacity = 1
            }
        }, 0);
    }

    changeTheName = (theValue) => {
        let theId = this.props.subTask.subtaskId
        this.props.changeSubtaskName(theValue, theId)
    }
    autoReset = (theValue) => {
        let subtaskTitleId = "subtask-title-" + this.props.subTask.subtaskId
        if(theValue === 'New Subtask') {
            document.getElementById(subtaskTitleId).value = ''
        }
    }
    deleteTheSubtask = () => {
        let subTaskId = this.props.subTask.subtaskId
        this.props.deleteSubtask(subTaskId)
    }
    deleteMy2xSub = (sub2xId) => {
        let subTaskId = this.props.subTask.subtaskId
        this.props.delete2xSub(sub2xId, subTaskId)
    }
    addSubSubTask = () => {
        let subId = this.props.subTask.subtaskId
        this.props.addNewSubSub(subId)
    }
    changeMySubSubName = (theValue, theSubSubId) => {
        let subId = this.props.subTask.subtaskId
        this.props.changeSubSubName(theValue, theSubSubId, subId)
    }
    toggleAlarmClick(theValue) {
        let theState = this.state.dateChange
        let subtaskId = this.props.subTask.subtaskId
        let theDate = this.props.subTask.subtaskDueDate
        if(theState === false) {
            this.setState({dateChange: true})
        } else {
            this.props.changeSubtaskDueDate(theDate, subtaskId)
            this.setState({dateChange: false})
        }
    }
    closeAlarmClick = (theValue) => {
        let theId = this.props.subTask.subtaskId
        this.props.changeDueDate(theValue, theId)
        this.setState({
            dateChange: false
        })
    }
    render() {
        const theDate = new Date(this.props.subTask.subtaskDueDate)
        const month = theDate.getMonth() + 1
        const day = theDate.getDate()
        const year = theDate.getFullYear()
        let subtaskId = "subtask-" + this.props.subTask.subtaskId
        let checkMarkId = 'subtask-checkmark-' + this.props.subTask.subtaskId
        let subtaskTitleId = "subtask-title-" + this.props.subTask.subtaskId
        if(this.props.whichList === 'todos') {
            return (
                <div>
                    <div className="the-subtask" id={subtaskId}>
                        <div className="subtask-checkmark" id={checkMarkId} onClick={() => this.deleteTheSubtask()}></div>
                        <input className="subtask-title" id={subtaskTitleId} value={this.props.subTask.subtaskName} onClick={(e) => this.autoReset(e.target.value)} onChange={(e) => this.changeTheName(e.target.value)} />
                        <div className="icon-area">
                            <div className="subtask-alarm-wrapper">
                                <div className="subtask-alarm-icon" id="subtask-alarm-icon" onClick={() => this.toggleAlarmClick()}></div>
                                <h5 className="subtask-card-due">Due: {month}/{day}</h5>
                                <TaskDatePopup 
                                    subtask={this.props.subTask}
                                    //sortByDueDate = {this.props.sortByDueDate}
                                    dateChange={this.state.dateChange} 
                                    toggleAlarmClick={(theValue) => this.toggleAlarmClick(theValue)}
                                />
                            </div>
                            <div className="add-subtask" onClick={() => this.addSubSubTask()}></div>
                        </div>
                    </div>
                    {this.props.subTask.subtaskSubtasks.map(subsub => <SubSubTask key={subsub.subtask2xId} changeSubSubName={(theValue, theSubSubId) => this.changeMySubSubName(theValue, theSubSubId)} delete2xsub={(sub2xId) => this.deleteMy2xSub(sub2xId)} subsub={subsub} />)}
                </div>
            )
        } else {
            return (
                <div>
                    <div className="the-subtask" id={subtaskId}>
                        <div className="subtask-checkmark" id={checkMarkId} onClick={() => this.deleteTheSubtask()}></div>
                        <input className="subtask-title" id={subtaskTitleId} value={this.props.subTask.subtaskName} onClick={(e) => this.autoReset(e.target.value)} onChange={(e) => this.changeTheName(e.target.value)} />
                        <div className="workflow-icon-area icon-area">
                        {/* <div className="subtask-alarm-wrapper">
                            <div className="subtask-alarm-icon" id="subtask-alarm-icon" onClick={() => this.toggleAlarmClick()}></div>
                            <h5 className="subtask-card-due">Due: {month}/{day}</h5>
                            <TaskDatePopup 
                                subtask={this.props.subTask}
                                sortByDueDate = {this.props.sortByDueDate}
                                dateChange={this.state.dateChange} 
                                toggleAlarmClick={(theValue) => this.toggleAlarmClick(theValue)}
                            />
                        </div> */}
                            <div className="workflow-add-subtask add-subtask" onClick={() => this.addSubSubTask()}></div>
                        </div>
                    </div>
                    {this.props.subTask.subtaskSubtasks.map(subsub => <SubSubTask key={subsub.subtask2xId} changeSubSubName={(theValue, theSubSubId) => this.changeMySubSubName(theValue, theSubSubId)} delete2xsub={(sub2xId) => this.deleteMy2xSub(sub2xId)} subsub={subsub} />)}
                </div>
            )
        }
    }
}
export default Subtask